/**
 * FormField — shared form field with icon + label + required indicator.
 */

import type { FormFieldProps } from './types';
import { MODAL_COLORS } from './constants';

export function FormField({ icon, label, required, children }: FormFieldProps) {
  const dir =
    typeof document !== 'undefined'
      ? document.documentElement.dir || 'ltr'
      : 'ltr';

  return (
    <div className="space-y-1.5">
      <div className="flex items-center gap-1.5" dir={dir}>
        <span className="w-4 h-4" style={{ color: MODAL_COLORS.text, opacity: 0.7 }}>
          {icon}
        </span>
        <label className="text-xs font-semibold" style={{ color: MODAL_COLORS.text }}>
          {label}
          {required && <span style={{ color: '#EF4444' }}> *</span>}
        </label>
      </div>
      {children}
    </div>
  );
}
